import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import MetaInfo from 'vue-meta-info'
import router from './router'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(MetaInfo)


new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')
